import { useLocation, useNavigate, useParams } from "react-router-dom";

const toDestination = (destination) => {
    if (typeof destination === "string") return destination;
    const { pathname, search = "", hash = "", query, state } = destination;
    return {
        pathname,
        search,
        hash,
        state: query ? { ...state, query } : state,
    };
};

export const withRouter = (Component) => {
    const ComponentWithRouter = (props) => {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();
        const legacyLocation = {
            ...location,
            query: location.state?.query,
        };
        const history = {
            location: legacyLocation,
            push: (destination) => navigate(toDestination(destination)),
            replace: (destination) =>
                navigate(toDestination(destination), { replace: true }),
            goBack: () => navigate(-1),
        };

        return (
            <Component
                {...props}
                history={history}
                location={legacyLocation}
                match={{ params }}
                navigate={navigate}
                params={params}
            />
        );
    };

    ComponentWithRouter.displayName = `withRouter(${Component.displayName || Component.name || "Component"})`;
    return ComponentWithRouter;
};
